import React, { useState } from 'react'

import { Button, Col, Input, Row } from 'antd'
import { Moment } from 'moment'

import DatePicker from 'common/components/dataEntry/components/DatePicker'
import Icon from 'common/components/general/Icon'

interface searchFieldsProps {
  onSearch: (value: any) => void
  translate: (key: string) => string
}

const SearchFields: React.FC<searchFieldsProps> = ({ onSearch, translate }) => {
  const [companyId, setCompanyId] = useState<string>()
  const [migrationDate, setMigrationDate] = useState<string>()

  const searchCompany = (e: any) => {
    const value = e.target.value
    setCompanyId(value)
    if (e.keyCode == 13) {
      onSearchClick()
    }
  }

  const onMigrationDateChange = (date: Moment | null, dateString: string) => {
    setMigrationDate(dateString)
  }

  const onSearchClick = () => {
    const searchReq = {
      companyId: companyId,
      migrationDate: migrationDate,
    }

    onSearch(searchReq)
  }

  return (
    <div>
      <Row className="mt-16">
        <Col span={8}>
          <p className="mb-8">{translate('csi-dashboard.migration.company-id')}</p>
          <div className="flex flex__space_between">
            <Input suffix={searchIcon} onKeyUp={searchCompany} className="mr-8"></Input>
          </div>
        </Col>
        <Col span={1}></Col>
        <Col span={8}>
          <p className="mb-8">{translate('csi-dashboard.migration.migration-date')}</p>
          <div className="flex flex__start">
            <DatePicker
              name="migrationDate"
              size="large"
              className="mr-8"
              format={'MM/DD/YYYY'}
              onChange={onMigrationDateChange}
            ></DatePicker>
          </div>
        </Col>
      </Row>
      <Row className="mt-16">
        <Col span={8}>
          <Button type="primary" onClick={onSearchClick}>
            {translate('general.search')}
          </Button>
        </Col>
      </Row>
    </div>
  )
}

const searchIcon = <Icon type="fal fa-search" fontAwesome />

export default SearchFields
